// extracted by mini-css-extract-plugin
export default {"container_footer":"Footer_container_footer__PaZJw","title_footer":"Footer_title_footer__8-Gat","container_redes":"Footer_container_redes__p5xEO"};